import React from 'react';
import { ShowButton, Datagrid, TextField, FunctionField, Filter, TextInput, ReferenceInput, SelectInput } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import AccountingAccountListActions from './AccountingAccountListActions';

const AccountingAccountFilter = props => (
	<Filter {...props}>
		<TextInput
			alwaysOn="true"
			label="resources.accountingAccounts.filter.ownerType"
			source="ownerType"
			resettable
		/>
		<TextInput alwaysOn="true" label="resources.accountingAccounts.filter.ownerId" source="ownerId" resettable />
		<TextInput
			alwaysOn="true"
			label="resources.accountingAccounts.filter.accountTypeCode"
			source="accountTypeCode"
			resettable
		/>
		<ReferenceInput
			alwaysOn
			source="currencyCode"
			reference="currencies"
			label="resources.accountingAccounts.filter.currencyCode"
		>
			<SelectInput optionText="id" resettable />
		</ReferenceInput>
		<TextInput
			alwaysOn="true"
			label="resources.accountingAccounts.filter.accountQualifier"
			source="accountQualifier"
			resettable
		/>
		<ReferenceInput
			alwaysOn
			source="subsidiaryId"
			reference="subsidiaries"
			label="resources.accountingAccounts.filter.subsidiaryId"
		>
			<SelectInput optionText="id" resettable />
		</ReferenceInput>
	</Filter>
);

const AccountingAccountList = props => (
	<TList {...props} filters={<AccountingAccountFilter />} actions={<AccountingAccountListActions />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" sortable={false} />
			<TextField source="subsidiaryId" sortable={false} />
			<TextField source="accountType.accountTypeCode" sortable={false} />
			<TextField source="accountType.description" sortable={false} />
			<FunctionField
				source="owner"
				sortable={false}
				render={record => (
					<span>
						{record.owner.type}
						<br />
						{record.owner.id}
					</span>
				)}
			/>
			<TextField source="currencyCode" sortable={false} />
			<TextField source="qualifier" sortable={false} />
			<TextField source="trafficType" sortable={false} />
			<AmountField source="accountBalance" sortable={false} />
		</Datagrid>
	</TList>
);

export default AccountingAccountList;
